<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lf9dfh/tc-custom/9781504034432.jpg?1734210576462" alt="This image is the cover for the book They Called Him Stonewall"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">They Called Him Stonewall
      </h1>
      <p class="bookDescription body article font2">
        <b>The <i>New York Times</i>–bestselling biography of the South’s most brilliant and audacious military commander: “Completely fascinating” (<i>Kirkus Reviews</i>).</b><br/><br/> With the exception of Robert E. Lee, no Confederate general was more feared or admired than Thomas “Stonewall” Jackson. Once derisively known as “Tom Fool,” Jackson was an innovative battlefield strategist who struck terror in the hearts of Union army commanders and inspired Confederate soldiers to victory after victory in the early days of the Civil War.<br/><br/> A fanatically religious man, Jackson prayed at the start and conclusion of every battle—yet showed no mercy when confronting the enemy. Eccentric, enigmatic, and fiercely intelligent, he became the stuff of legend soon after he died from wounds suffered during the Battle of Chancellorsville; his untimely death would help to change the course of the conflict. Based on a wealth of first-person sources, including Jackson’s private papers and correspondences, and the memoirs of family, friends, and colleagues, <i>They Called Him Stonewall </i>is a masterful portrait of the man behind the myth.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Burke Davis
      </h2>
      
      <p class="authorDescription body article">Burke Davis (1913&ndash;2006) was an American author and journalist best known for his narrative histories of the Civil War, including <I>To Appomattox: Nine April Days, 1865 </I>(1959), <I>Sherman&rsquo;s March </I>(1980), and <I>The Last Surrender </I>(1985). His acclaimed biographies of military and political figures include <I>They Called Him Stonewall </I>(1954), <I>Gray Fox: Robert E. Lee and the Civil War </I>(1956), <I>Marine!: The Life of Chesty Puller </I>(1962), and <I>Old Hickory: A Life of Andrew Jackson </I>(1977). A longtime special projects writer for Colonial Williamsburg, Davis also published many works of historical nonfiction for young readers. His numerous honors include the Mayflower Cup, the North Carolina Award for Literature, and election to the North Carolina Journalism Hall of Fame and the North Carolina Literary Hall of Fame.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8d4686c0